import * as React from 'react'
import {
  PageHeader,
  SubTitle,
  TitleLink
} from 'src/components/layout/PageHeader'
import { Auth } from 'src/components/Auth'
import { PageContent } from 'src/components/layout/PageContent'
import { Paper } from 'src/components/Paper'
import { SEO } from 'src/components/Seo'

const Login = () => {
  return (
    <>
      <SEO {...{ title: 'Login' }} />
      <PageContent>
        <PageHeader title={'Login'}>
          <SubTitle>
            Don't have an account?{' '}
            <TitleLink to={'/signup'}>Sign up!</TitleLink>
          </SubTitle>
        </PageHeader>
        <Paper>
          <Auth {...{ context: 'login' }} />
        </Paper>
      </PageContent>
    </>
  )
}

export default Login
